import { TextInputProps } from "@/types";

type Option = { label: string; value: string };

export const filters = (tiers: Option[]): TextInputProps[] => [
	{
		name: "tier",
		label: "Tier",
		type: "select",
		placeholder: "All",
		options: tiers,
	},
	{
		name: "status",
		label: "Status",
		type: "select",
		options: [
			{ label: "All", value: "all" },
			{ label: "Active", value: true },
			{ label: "Inactive", value: false },
		],
	},
];
